<template>
  <a class="nav-link position-relative h-100 d-flex align-items-center" :class="linkClass" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
    <span :class="spanClass">{{ wishListCount }}</span>
    <span v-if="logo.length > 0" class="logo-navbar" :style="{ 'background-image' : `url('${logo}')` }"></span>
    <i v-else class="fa" :class="[wishListCount ? 'fa-heart' : 'fa-heart-o', iconClass ]" aria-hidden="true"/>
  </a>
</template>

<script>
export default {
  props: {
    logo: {type: String, default:''},
    linkClass: {type: String, default: ''},
    spanClass: {type: String},
    iconClass: {type: String}
  },
  computed:
            {
              wishListCount () {
                return this.$store.getters.wishListCount
              },

              urlWishList () {
                return App.urls.wishList
              }
            }
}
</script>
